/* Floating Video Component JS */

document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('product-floating-video');
  if (!container) return;



  const video = container.querySelector('.floating-video-element');
  const closeBtnCollapsed = container.querySelector('.floating-video-close');
  const backdrop = document.getElementById('product-floating-video-backdrop');

  // Relocate to document.body to escape parent stacking context or overflow hidden blocks
  if (backdrop) document.body.appendChild(backdrop);
  document.body.appendChild(container);

  // Expanded controls
  const controlsOverlay = container.querySelector('.floating-video-controls-overlay');
  const closeBtnExpanded = container.querySelector('.btn-close-expanded');
  const playPauseBtn = container.querySelector('.floating-video-play-pause');
  const muteBtn = container.querySelector('.floating-video-mute-toggle');
  


  if (!video) return;

  // 1. Initial Entry Slide-in Animation
  setTimeout(function () {
    container.setAttribute('data-state', 'visible');
    // Ensure video is autoplaying
    video.play().catch(err => console.log("Autoplay blocked:", err));
  }, 1200);

  // 2. Play/Pause state tracking & UI updates
  const playIcon = playPauseBtn ? playPauseBtn.querySelector('.icon-play') : null;
  const pauseIcon = playPauseBtn ? playPauseBtn.querySelector('.icon-pause') : null;

  function updatePlayPauseUI() {
    if (!playPauseBtn) return;
    if (video.paused) {
      if (playIcon) playIcon.style.display = 'block';
      if (pauseIcon) pauseIcon.style.display = 'none';
    } else {
      if (playIcon) playIcon.style.display = 'none';
      if (pauseIcon) pauseIcon.style.display = 'block';
    }
  }

  // 3. Mute/Unmute state tracking & UI updates
  const muteIcon = muteBtn ? muteBtn.querySelector('.icon-volume-mute') : null;
  const volumeUpIcon = muteBtn ? muteBtn.querySelector('.icon-volume-up') : null;

  function updateMuteUI() {
    if (!muteBtn) return;
    if (video.muted) {
      if (muteIcon) muteIcon.style.display = 'block';
      if (volumeUpIcon) volumeUpIcon.style.display = 'none';
    } else {
      if (muteIcon) muteIcon.style.display = 'none';
      if (volumeUpIcon) volumeUpIcon.style.display = 'block';
    }
  }

  // Initial updates
  updatePlayPauseUI();
  updateMuteUI();

  // 4. Click handlers for Collapsed & Expanded states
  container.addEventListener('click', function (e) {
    const state = container.getAttribute('data-state');
    
    // Ignore clicks on control overlays, buttons, or option groups
    if (e.target.closest('.floating-video-close') ||
        e.target.closest('.floating-video-controls-overlay') || 
        e.target.closest('.floating-video-mute-toggle')) {
      return;
    }

    if (state === 'visible' || state === 'collapsed') {
      expandVideo();
    }
  });

  // Action: Expand
  function expandVideo() {
    container.setAttribute('data-state', 'expanded');
    if (backdrop) backdrop.classList.add('active');
    
    // Unmute and play on expand
    video.muted = false;
    updateMuteUI();
    if (video.paused) {
      video.play().then(updatePlayPauseUI).catch(err => console.log(err));
    } else {
      updatePlayPauseUI();
    }
  }

  // Action: Minimize
  function minimizeVideo() {
    container.setAttribute('data-state', 'visible');
    if (backdrop) backdrop.classList.remove('active');
    
    // Mute on minimize
    video.muted = true;
    updateMuteUI();
  }

  // Action: Dismiss Completely
  function dismissVideo() {
    video.pause();
    video.muted = true;
    updateMuteUI();

    // Smooth fade out animation before removing
    container.style.transition = 'all 0.3s ease';
    container.style.opacity = '0';
    container.style.transform = container.getAttribute('data-state') === 'expanded' 
      ? 'translate(50%, 50%) scale(0.9)' 
      : 'scale(0.8)';
    
    if (backdrop) backdrop.classList.remove('active');
    
    setTimeout(function () {
      container.style.display = 'none';
    }, 300);
  }

  // Button Listeners
  if (closeBtnCollapsed) {
    closeBtnCollapsed.addEventListener('click', function (e) {
      e.stopPropagation();
      dismissVideo();
    });
  }

  if (closeBtnExpanded) {
    closeBtnExpanded.addEventListener('click', function (e) {
      e.stopPropagation();
      minimizeVideo();
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', function () {
      minimizeVideo();
    });
  }

  if (playPauseBtn) {
    playPauseBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (video.paused) {
        video.play().then(updatePlayPauseUI);
      } else {
        video.pause();
        updatePlayPauseUI();
      }
    });
  }

  if (muteBtn) {
    muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      updateMuteUI();
    });
  }



  // Prevent double click scaling or selection
  container.addEventListener('dblclick', function (e) {
    e.preventDefault();
  });

  // 6. Sticky Footer Adjustment
  const stickyFooter = document.getElementById('sticky-footer');
  function adjustForStickyFooter() {
    if (!stickyFooter) return;
    if (stickyFooter.classList.contains('show')) {
      container.classList.add('has-sticky-footer');
    } else {
      container.classList.remove('has-sticky-footer');
    }
  }

  window.addEventListener('scroll', adjustForStickyFooter);
  window.addEventListener('resize', adjustForStickyFooter);
  
  if (stickyFooter) {
    const observer = new MutationObserver(adjustForStickyFooter);
    observer.observe(stickyFooter, { attributes: true, attributeFilter: ['class'] });
  }
  
  adjustForStickyFooter();
});
